export const validationLogin = new RegExp (
    /^(?=.*[.])/gm
);

export const isValidEmail = new RegExp(
    /\S+@\S+\.\S+/
); 
    
  